// extracted by css-extract-rspack-plugin
export default {"root":"MetricEditorFooter-module__root___KQ1sl"};